export default __webpack_public_path__ + "static/media/24-image.4fca8443.png";